import { cn } from "@/libs/cn";
import { TotalizersCard, TotalizersCardSkeleton } from "@/modules/common/components";
import { AdminDashboardOverview } from "@/service/response/admin-dashboard";
import { Building2Icon, Factory, Network, Users, Zap } from "lucide-react";

interface SummaryTotalizersParams {
  data?: AdminDashboardOverview;
  isLoading?: boolean;
  className?: string;
}

const subValueRender = (delta: number) => {
  return (
    <p className={cn(delta > 0 ? "text-green-500" : delta < 0 ? "text-red-500" : "")}>
      {delta > 0 ? `+${delta} este mês` : delta < 0 ? `${delta} este mês` : "-"}
    </p>
  );
};

const SummaryTotalizers = ({ data, isLoading, className }: SummaryTotalizersParams) => {
  return (
    <div className={cn("grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 items-stretch", className)}>
      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="Gestoras"
          value={data?.totalManagementCompanies.total!}
          subValue={subValueRender(data?.totalManagementCompanies.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-sky-800/20 rounded-lg">
              <Building2Icon className="w-5 h-5 text-blue-900 font-bold" />
            </div>
          }
        />
      )}

      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="Gestora - Gestão de Terceiros"
          value={data?.thirdPartyManagementCompanies.total}
          subValue={subValueRender(data?.thirdPartyManagementCompanies.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-sky-800/20 rounded-lg">
              <Network className="w-5 h-5 text-blue-900 font-bold" />
            </div>
          }
        />
      )}

      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="Gestoras - Gestão Própria"
          value={data?.ownManagementCompanies.total}
          subValue={subValueRender(data?.ownManagementCompanies.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-emerald-200/20 rounded-lg">
              <Factory className="w-5 h-5 text-green-700 font-bold" />
            </div>
          }
        />
      )}

      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="Clientes"
          value={data?.totalClients.total!}
          subValue={subValueRender(data?.totalClients.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-sky-800/20 rounded-lg">
              <Users className="w-5 h-5 text-blue-900 font-bold" />
            </div>
          }
        />
      )}

      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="Usuários"
          value={data?.totalUsers.total}
          subValue={subValueRender(data?.totalUsers.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-sky-100 rounded-lg">
              <Users className="w-5 h-5 text-blue-500 font-bold" />
            </div>
          }
        />
      )}

      {isLoading ? (
        <TotalizersCardSkeleton />
      ) : (
        <TotalizersCard
          title="UCs"
          value={data?.totalConsumerUnits.total}
          subValue={subValueRender(data?.totalConsumerUnits.delta ?? 0)}
          icon={
            <div className="flex items-center justify-center p-2 bg-emerald-200/20 rounded-lg">
              <Zap className="w-5 h-5 text-green-700 font-bold" />
            </div>
          }
        />
      )}
    </div>
  );
};

export default SummaryTotalizers;
